var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareCarousel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79999 2.39999C8.35817 2.39999 7.99999 2.75817 7.99999 3.19999C7.99999 3.64182 8.35817 3.99999 8.79999 3.99999H10.8686L5.83431 9.03431C5.52189 9.34673 5.52189 9.85326 5.83431 10.1657C6.14673 10.4781 6.65326 10.4781 6.96568 10.1657L12 5.13136V7.19999C12 7.64182 12.3582 7.99999 12.8 7.99999C13.2418 7.99999 13.6 7.64182 13.6 7.19999V3.19999C13.6 2.75817 13.2418 2.39999 12.8 2.39999H8.79999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99999 3.99999C3.11634 3.99999 2.39999 4.71634 2.39999 5.59999V12C2.39999 12.8837 3.11634 13.6 3.99999 13.6H10.4C11.2837 13.6 12 12.8837 12 12V9.59999C12 9.15817 11.6418 8.79999 11.2 8.79999C10.7582 8.79999 10.4 9.15817 10.4 9.59999V12H3.99999V5.59999L6.39999 5.59999C6.84182 5.59999 7.19999 5.24182 7.19999 4.79999C7.19999 4.35817 6.84182 3.99999 6.39999 3.99999H3.99999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareCarousel);
export default __webpack_public_path__ + "static/media/share-carousel.b823076a7e0fdb9b64fde78ccfdf5028.svg";
export { ForwardRef as ReactComponent };